import { Col, Row, theme } from 'antd'
import { FC } from 'react'
import dayjs from 'dayjs'
import { outputDateFormat } from '../../../../../constants/constants'
import { CheckCircleFilled, ClockCircleFilled, PauseCircleFilled } from '@ant-design/icons'
import FormOrder, { OrderStatus } from '../../../../../types/api/form-order'

interface FormsInfoProps {
    formOrders?: FormOrder[]
}

const FormsInfo: FC<FormsInfoProps> = ({ formOrders }) => {
    const { token } = theme.useToken()

    const getIconByStatus = (status: OrderStatus) => {
        switch (status) {
            case 'Создан':
                return <PauseCircleFilled style={{ color: token.yellow5 }} />
            case 'В пути':
                return <PauseCircleFilled style={{ color: token.blue5 }} />
            case 'В сборке':
                return <ClockCircleFilled style={{ color: token.blue5 }} />
            case 'Готов к выдаче':
                return <CheckCircleFilled style={{ color: token.green5 }} />
            case 'Завершен':
                return <CheckCircleFilled style={{ color: token.green5 }} />
        }
    }

    if (!formOrders?.length) {
        return (
            <Row gutter={12}>
                <Col>нет заказов форм</Col>
            </Row>
        )
    }

    const sortedOrders = [...formOrders].sort((a, b) => a.id - b.id)

    return (
        <>
            {sortedOrders.map(order => {
                const formattedDate = order.estimatedDate
                    ? dayjs(order.estimatedDate).format(outputDateFormat)
                    : null
                const dateLabel =
                    formattedDate && order.orderStatus === 'Создан'
                        ? `Дата поставки ${formattedDate}`
                        : formattedDate || 'без даты'

                return (
                    <Row gutter={12} key={order.documentId}>
                        <Col style={{ width: 120 }}>Заказ № {order.id}</Col>
                        <Col style={{ width: 90 }}>
                            {order.orderStatus ? getIconByStatus(order.orderStatus) : ''}{' '}
                            {order.orderStatus ?? 'статус неизвестен'}
                        </Col>
                        <Col>{dateLabel}</Col>
                    </Row>
                )
            })}
        </>
    )
}

export default FormsInfo
